import { LuArrowLeftRight, LuBanknote, LuCoins, LuFileText, LuTrendingDown } from 'react-icons/lu';

import { ManagementSettings } from './types';

export type ManagementToggleKey = Extract<keyof ManagementSettings, 'taxLossHarvesting' | 'cashEqSweep'>;

export interface ManagementFlag {
    title: string;
    description: string;
    icon: React.ComponentType<{ className?: string }>;
    requiresTaxable?: boolean;
    toggleKey?: ManagementToggleKey;
}

export const MANAGEMENT_FLAGS: ManagementFlag[] = [
    {
        title: 'Automated billing',
        description: 'Auto-raise cash for advisory fees each billing cycle.',
        icon: LuFileText,
    },
    {
        title: 'Automated withdrawals',
        description: "Auto-raise cash for scheduled withdrawals related to a client's plan.",
        icon: LuBanknote,
    },
    {
        title: 'Tax-aware rebalancing',
        description: 'Limit realized capital gains and prioritize tax benefits while rebalancing.',
        icon: LuArrowLeftRight,
        requiresTaxable: true,
    },
    {
        title: 'Tax Loss Harvesting',
        description:
            'Harvest large losses automatically or on demand, and replace harvested assets with similar alternatives.',
        icon: LuTrendingDown,
        requiresTaxable: true,
        toggleKey: 'taxLossHarvesting',
    },
    {
        title: 'CashEQ sweep',
        description:
            'Idle available cash is swept into higher-yield equivalents, keeping uninvested cash to a minimum.',
        icon: LuCoins,
        toggleKey: 'cashEqSweep',
    },
];

export const TAXABLE_FOOTNOTE =
    '* Tax Loss Harvesting and tax-aware rebalancing will only be enabled on taxable accounts.';
